import restUrls from "web/constants/restUrls";

import api from "../api/apiSlice";

export enum EmploymentContractType {
  INDEFINITE_TERM = "INDEFINITE_TERM",
  FIXED_TERM = "FIXED_TERM",
  TRIAL_PERIOD = "TRIAL_PERIOD",
  REPLACEMENT = "REPLACEMENT",
}

export enum EmploymentForm {
  B2B = "B2B",
  CONTRACT_OF_EMPLOYMENT = "CONTRACT_OF_EMPLOYMENT",
  SPECIFIC_TASK_CONTRACT = "SPECIFIC_TASK_CONTRACT",
  MANDATE_CONTRACT = "MANDATE_CONTRACT",
  INTERNSHIP = "INTERNSHIP",
  VOLUNTARY_WORK = "VOLUNTARY_WORK",
  AGENCY_CONTRACT = "AGENCY_CONTRACT",
  MANAGEMENT_CONTRACT = "MANAGEMENT_CONTRACT",
  BODY_LEASING = "BODY_LEASING",
}

export type EmployeeMeEmployment = {
  employeeId: string;
  dailyWorkingHours: string;
  contractFrom: string | null;
  contractTo: string | null;
  contractType: EmploymentContractType | null;
  employmentForm: EmploymentForm | null;
  workingHoursFractionDenominator: number | null;
  workingHoursFractionNominator: number | null;
};

export interface IOrganizationStructureEmployeeMeDataResponse {
  avatar: string | null;
  position: { id: string; value: string } | null;
  isAreaManager: boolean;
  isEmployeeSupervisor: boolean;
  companyOrganizationStructureModules: {
    cardAndListModuleEnabled: boolean;
    structureAreasOrgChartModuleEnabled: boolean;
    structureEmployeesOrgChartModuleEnabled: boolean;
  };
  presenceInformation: {
    dailyWorkingHours: string;
    contractFrom: string | null;
    contractTo: string | null;
    contractType: EmploymentContractType | null;
    employmentForm: EmploymentForm | null;
    workingHoursFractionDenominator: number | null;
    workingHoursFractionNominator: number | null;
  } | null;
  employeeEmployment: EmployeeMeEmployment;
}

export const organizationStructureApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationStructureEmployeeMeData: builder.query<
      IOrganizationStructureEmployeeMeDataResponse,
      void
    >({
      query: () => ({
        url: restUrls.organizationStructureEmployeeMe,
      }),
      providesTags: ["OrganizationStructureEmployeeMeData"],
    }),
  }),
});

export const { useGetOrganizationStructureEmployeeMeDataQuery } =
  organizationStructureApiSlice;
